import { assertNever, SurveyQuestion, ScoreValueMapping, SelectionSummary, ScoredSelectionStats, UnscoredSelectionStats, ISelectionStats } from '..';
import { DefaultScoreValueMapping, DefaultSurveyQuestionOptions, SurveyQuestionConfig, SurveyQuestionOption } from '../DTOs/survey/SurveyQuestion';

export const surveyQuestionHelper =
{
    isScoredQuestion,
    getOptions,
    getScoreMapping,
    toSelectionStats,
    getSurveyQuestionConfig
}

function isScoredQuestion(question:SurveyQuestion):boolean
{
    if(question.type === 'default')
        return true;
    else if(question.type === 'custom')
        return question.scored;
    else if(question.type === 'multiple-choice')
        return false;
    else
    {
        assertNever(question);
        throw new Error('Unsupported question type');
    }
}

function getOptions(question:SurveyQuestion):SurveyQuestionOption[]
{
    if(question.type === 'default')
        return DefaultSurveyQuestionOptions;
    else if(question.type === 'custom')
        return question.options;
    else if(question.type === 'multiple-choice')
        return question.options;
    else {
        assertNever(question);
        throw new Error('Unsupported question type');
    }
}

function getScoreMapping(question:SurveyQuestion): ScoreValueMapping[]
{
    if(isScoredQuestion(question)){
        if(question.type === 'default'){
            return DefaultScoreValueMapping;
        }
        else if(question.type === 'custom'){
            if(question.scored)
                return question.options.map(o => ({ value:o.value, score:o.score }));
            else
                throw new Error('Attempted to get score mapping for unscored custom question');
        }
        else if(question.type === 'multiple-choice')
            throw new Error('Attempted to get score mapping for multiple-choice question');
        else {
            assertNever(question);
            throw new Error('Unsupported question type');
        }
    }
    else
        throw new Error('Attempted to get score mapping for unscored question');
}

function toSelectionStats(question:SurveyQuestion, selectionSummary:SelectionSummary):ISelectionStats
{
    if(isScoredQuestion(question)){
        return new ScoredSelectionStats(selectionSummary, getScoreMapping(question));
    }
    else
        return new UnscoredSelectionStats(selectionSummary);
}

function getSurveyQuestionConfig(question: SurveyQuestion): SurveyQuestionConfig
{
    if(question.type === 'default')
        return {
            type: 'default',
            invertScore: question.invertScore
        };
    else if(question.type === 'custom')
    {
        if(question.scored)
        {
            return {
                type: 'custom',
                scored: true as const,
                options: question.options,
            };
        }
        else {
            return {
                type: 'custom',
                scored: false as const,
                options: question.options,
            }
        }
    }
    else if(question.type === 'multiple-choice')
    {
        return {
            type: 'multiple-choice',
            options: question.options
        };
    }
    else {
        assertNever(question);
        throw new Error('Unsupported question type');
    }
}